import { useEffect, useContext, useState } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import getDynamicRecs from '../queries/dynamicrecs/getDynamicRecsQuery';
import { useQuery } from './useQuery';

const useDynamicRecs = ({
  itemId,
  storeId,
  domains = ['fbt'],
  productDomains = ['identifiers'],
  ssr = false,
  skip = false,
  irgMaxItems = 5,
  options
}) => {

  const ctx = useContext(ExperienceContext);
  const [sId, setStoreId] = useState(storeId);
  const opts = {
    ssr,
    skip,
    errorPolicy: 'all',
    variables: {
      itemId,
    }
  };

  if (sId) {
    opts.variables.storeId = sId;
  }

  if (domains.indexOf('irg') > -1) {
    opts.variables.maxItems = irgMaxItems;
  }
  const Query = getDynamicRecs({ domains, productDomains });
  const resp = useQuery(Query, opts);

  useEffect(() => {
    // only use storeId clientside or if passed in
    if (!sId && typeof window !== 'undefined' && !resp.loading && !opts.skip) {
      if (ctx && ctx.store) {
        setStoreId(ctx.store.storeId);
      }
    }
  }, [resp.loading]);

  return resp;
};

export default useDynamicRecs;
